import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../Dashboard/Header";
import FooterStrict from "../Dashboard/FooterStrict";
import LineAnalysisChart from "../../Components/LineAnalysisChart";
import BarAnalysisChart from "../../Components/BarAnalysisChart";

import {
  getFilter,
  getYearRevenue,
  getYearUnitSold,
  getYearUnitcategory,
  getFilterCategoryid,

} from "../../API/Chart";
import BrandImg from "../../Assets/images/shoppers.svg";
import { dropDownOnChangeHandleAllOrOthers } from "../../helper";
import { getCustomCategories,getAllCategories } from "../../API/Category";


function getFilterOptions(array, labelKey, valueKey) {
  
  if (!labelKey && !valueKey) {
    return array.map((item) => ({ value: item, label: item }));
  }
  return array.map((item) => ({
    value: item[valueKey],
    label: item[labelKey]
  }));
}

const Tabs = {
  unitsSold: "unitsSold",
  revenue: "revenue",
  barChart: "barChart",
  weekly: "weekly",
  monthly: "monthly"
};

const ItemCategoryAnalyzer = () => {
  const { cacid } = useParams();
  const isInitialLoad = useRef(true);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(Tabs.weekly);
  const [weeklyUnitsSold, setWeeklyUnitsSold] = useState([]);
  const [weeklyRevenue, setWeeklyRevenue] = useState([]);
  const [ShopperCount, setShopperCount] = useState([]);
  const [brandsData, setBrandsData] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [showError, setShowError] = useState(false);

  const [yearRevenue, setYearRevenue] = useState([]);
  const [yearUnitcategory, setYearUnitcategory] = useState([]);
  const [yearUnitSold, setYearUnitSold] = useState([]);




  const [filterOptions, setFilterOptions] = useState({
    brands: [],
    retailers: [],
    dateRanges: [],
    loyaltyOptions: [],
    storeOptions: [],
    retailerFilters: [],
    wholesalers: []
  });

  const defaultFilters = {
    Brands: "",
    BusinessType: "",
    BusinessTypefilterBy: "",
    StartDate: "",
    EndDate: "",
    Loyalty: "",
    Stores: ""
  };

  const brands = (ShopperCount?.brands?.length ? ShopperCount.brands : filterOptions.brands)?.filter(b => b.label !== "All Brands");

  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedLoyalty, setSelectedLoyalty] = useState({});
  const [selectedStore, setSelectedStore] = useState({});

  const [filterBy, setFilterBy] = useState({});
  const [filterByValue, setFilterByValue] = useState([]);
  const [filters, setFilters] = useState(defaultFilters);
  const [filtersClone, setFiltersClone] = useState(null);

  async function getData(params = {}) {
    try {

      const _startDate = params.startDate || startDate;
      const _endDate = params.endDate || endDate;
      const _selectedBrands = params.selectedBrands || selectedBrands;
      const _filterBy = params.filterBy || filterBy;
      const _filterByValue = params.filterByValue || filterByValue;
      const _selectedLoyalty = params.selectedLoyalty || selectedLoyalty;
      const _selectedStore = params.selectedStore || selectedStore;


      const defaultFilters = {
        Brands: "",
        BusinessType:_filterBy,
        BusinessTypefilterBy: _filterByValue,
        StartDate: _startDate,
        EndDate: _endDate,
        Loyalty: _selectedLoyalty,
        Stores:_selectedStore
      };

      setFilters((prev) => ({
        ...prev,...defaultFilters
      }));
        setFiltersClone(defaultFilters);

      let _activeTab = activeTab
      if (params.activeTab) {
        _activeTab = params.activeTab;
        setActiveTab(_activeTab);
      }

      let dateErrorMsg = "";
      if (!_startDate && !_endDate) {
        dateErrorMsg = "Please select date range";
      } else if (!_startDate) {
        dateErrorMsg = "Please select start date";
      } else if (!_endDate) {
        dateErrorMsg = "Please select end date";
      }
      if (dateErrorMsg) {
        setShowError(true);
        setDateError(dateErrorMsg);
        return;
      }
      setShowError(false);
      setDateError("");

      setLoading(true);

      const urlParams = new URLSearchParams();

      if (_selectedBrands?.length) {
        urlParams.append("brands", _selectedBrands.map((i) => i.value).join(","));
      }

      if (_filterBy) {
        urlParams.append("filter_by", _filterBy.value);
      }

      if (_filterByValue?.length) {
        urlParams.append(
          "filter_by_value",
          _filterByValue.map((i) => i.value).join(",")
        );
      }

      if (_selectedLoyalty) {
        urlParams.append("loyalty", _selectedLoyalty.value);
      }

      if (_selectedStore) {
        urlParams.append("stores", _selectedStore.value);
      }

      if (cacid) {
        urlParams.append("cacid", cacid);
      }

      if (cacid) {
        urlParams.append("categoryid", cacid);
      }

      if (_startDate) {
        urlParams.append("start_date", _startDate);
      }

      if (_endDate) {
        urlParams.append("end_date", _endDate);
      }

      function updateShopperData(_shopperData) {
        setShopperCount(_shopperData || []);
        if (_shopperData?.brands) {
          setBrandsData(
            _shopperData.brands.map((item) => ({
              count: Number(item.value).toLocaleString(),
              label: item.label
            }))
          );
        }
      }
     
        const [yearRevenue, yearUnitcategory, yearUnitSold] =
          await Promise.all([
            getYearRevenue(urlParams),
            getYearUnitcategory(urlParams),
            getYearUnitSold(urlParams)
          ]);
          
        setYearRevenue(yearRevenue || []);
        setYearUnitcategory(yearUnitcategory || []);
        setYearUnitSold(yearUnitSold);
     
      setLoading(false);
    } catch (error) {
      console.error("❌ Error", error);
    } finally {
      setLoading(false);
    }
  }

  async function getFilterData() {
    const [_customCategories, _filterData] = await Promise.all([
      getAllCategories(),
      getFilterCategoryid(cacid),
    ]);

    setCategoryName(
      _customCategories?.find((c) => c.upc_category_id === +cacid)?.category_name ??
        ""
    );

    const convertedOptions = {
      // brands: getFilterOptions(_filterData?.brands, "", "") || [],
      retailerFilters:getFilterOptions(_filterData?.retailerFilters, "", "") || [],
      loyaltyOptions:getFilterOptions(_filterData?.loyaltyOptions, "", "") || [],
      storeOptions: getFilterOptions(_filterData?.storeOptions, "", "") || [],
      wholesalers: _filterData?.wholesalers,
      retailers: _filterData?.retailerGroups,
    };
    setFilterOptions(convertedOptions);

    const retailerFilter = convertedOptions.retailerFilters[0];
    setFilterBy(retailerFilter);

    const filterValue = retailerFilter?.value === "Wholesalers" 
      ? _filterData?.wholesalers?.[0]
      : _filterData?.retailerGroups[0];
    setFilterByValue(filterValue);

    // const selectedBrand = [convertedOptions.brands[0]];
    // setSelectedBrands(selectedBrand);
    
    const loyalty = convertedOptions.loyaltyOptions[0];
    setSelectedLoyalty(loyalty);
    
    const store = convertedOptions.storeOptions[0];
    setSelectedStore(store);

    const today = new Date();
    const ninetyDaysAgo = new Date(today.getTime() - 90 * 24 * 60 * 60 * 1000);

    const startDate = formatLocalDate(ninetyDaysAgo);
    const endDate = formatLocalDate(today);

    setEndDate(endDate);
    setStartDate(startDate);

    isInitialLoad.current = false;

    return {
      retailerFilter,
      filterValue,
      loyalty,
      store,
      startDate,
      endDate
    };
  }

  useEffect(() => {
    const initializeData = async () => {
      const filterData = await getFilterData();

      getData({
        startDate: filterData.startDate,
        endDate: filterData.endDate,
        filterBy: filterData.retailerFilter,
        filterByValue: filterData.filterValue,
        selectedLoyalty: filterData.loyalty,
        selectedStore: filterData.store
      });
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const isDeepEqual = (a, b) => {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
  
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;
      const sortedA = [...a].sort((x, y) =>
        JSON.stringify(x).localeCompare(JSON.stringify(y))
      );
      const sortedB = [...b].sort((x, y) =>
        JSON.stringify(x).localeCompare(JSON.stringify(y))
      );
      return sortedA.every((item, i) => isDeepEqual(item, sortedB[i]));
    }
  
    if (typeof a === "object" && a !== null && b !== null) {
      const keysA = Object.keys(a).sort();
      const keysB = Object.keys(b).sort();
      if (keysA.length !== keysB.length) return false;
      return keysA.every(
        (key, i) => keysB[i] === key && isDeepEqual(a[key], b[key])
      );
    }
  
    return a === b;
  };


  return (
    <>
      <Header location={`companyProfile`} />
      <section className="ContentBlock pt-40 pb-24 Main_Block">
        <div className="category-segment-section">
          <div className="container-fluid">
            <div className="Common_Block mb-30">
              <div className="Common_Block_Header d-flex align-items-center justify-content-between">
                <h5>Category: {categoryName}</h5>
                <Link
                  to="/categories"
                  style={{
                    background: "#fff",
                    color: "#3d8ecc",
                    border: "1px solid #3d8ecc",
                    fontWeight: 600,
                    padding: "6px 14px",
                    borderRadius: "6px",
                    textDecoration: "none",
                    fontSize: "14px"
                  }}
                >
                  ← Back to Categories
                </Link>
              </div>

              <div className="Common_Block_Body pt-17 pb-17 pr-14 pl-14">
                {/* Filter Bar */}
                <div className="sales-filters" style={{ marginBottom: "20px" }}>
                  {/* Filter by */}
                  <div className="filter-group">
                    <label>Filter by</label>
                    <Select
                      options={filterOptions.retailerFilters}
                      onChange={(e) => {
                        setFilterBy(e);
                        if (e?.value === "Wholesalers") {
                          setFilterByValue(filterOptions.wholesalers?.[0]);
                        } else {
                          setFilterByValue(filterOptions.retailers?.[0]);
                        }
                        setFilters((prev) => ({ ...prev, BusinessType: e }));
                      }}
                      value={filterBy}
                    />
                  </div>

                  {filterBy && (
                    <div className="filter-group">
                      <label>Select {filterBy.value || filterBy.label}</label>
                      <Select
                        isMulti
                        options={
                          filterBy.value === "Wholesalers"
                            ? filterOptions.wholesalers
                            : filterOptions.retailers
                        }
                        onChange={(selected) => {
                          let calculatedValue;
                          if (selected?.length > 1) {
                            if (selected.at(-1)?.label?.toLowerCase()?.startsWith("all")) {
                              calculatedValue = [selected.at(-1)];
                            } else if (selected?.findIndex((i) => i.label?.toLowerCase()?.startsWith("all")) !== -1) {
                              calculatedValue = selected.filter((i) => !i.label?.toLowerCase()?.startsWith("all"));
                            } else {
                              calculatedValue = selected;
                            }
                          } else {
                            calculatedValue = selected;
                          }
                          dropDownOnChangeHandleAllOrOthers(selected, setFilterByValue);
                          setFilters((prev) => ({ ...prev, BusinessTypefilterBy: calculatedValue }));
                        }}
                        value={filterByValue}
                      />
                    </div>
                  )}

                  {/* Loyalty */}
                  <div className="filter-group">
                    <label>Loyalty & NonLoyalty</label>
                    <Select
                      placeholder="Select Loyalty & NonLoyalty"
                      options={filterOptions.loyaltyOptions}
                      onChange={(selected) => {
                        setSelectedLoyalty(selected);
                        setFilters((prev) => ({
                          ...prev,
                          Loyalty: { label: selected?.value, value: selected?.value } || ""
                        }));
                      }}
                      value={selectedLoyalty}
                    />
                  </div>

                  {/* Onboard Stores */}
                  <div className="filter-group">
                    <label>CY & PY Onboard Stores</label>
                    <Select
                      placeholder="Select Onboard Stores"
                      value={selectedStore}
                      options={filterOptions.storeOptions}
                      onChange={(selected) => {
                        setSelectedStore(selected);
                        setFilters((prev) => ({
                          ...prev,
                          Stores: { label: selected?.value, value: selected?.value } || ""
                        }));
                      }}
                    />
                  </div>

                  {/* Apply */}
                  <div className="filter-group search-btn">
                    <br />
                    <button
                      onClick={() => getData()}
                      disabled={isDeepEqual(filters, filtersClone)}
                      style={{
                        padding: "8px 18px",
                        background: isDeepEqual(filters, filtersClone) ? "#ccc" : "#3d8ecc",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: isDeepEqual(filters, filtersClone) ? "not-allowed" : "pointer",
                        fontWeight: 500,
                        fontSize: "14px",
                        transition: "background 0.2s"
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>

                {/* YOY Analysis label */}
                <div style={{ marginBottom: "16px" }}>
                  <span style={{
                    display: "inline-block",
                    background: "#e8f4fd",
                    color: "#3d8ecc",
                    border: "1px solid #b8d8f0",
                    borderRadius: "4px",
                    padding: "5px 12px",
                    fontSize: "13px",
                    fontWeight: 600
                  }}>
                    YOY Analysis
                  </span>
                </div>

                {/* Charts */}
                <div className="produce-department shoppers-chart">
                  <div className="chart-wrapper">
                    {loading ? (
                      <div style={{
                        height: "300px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px"
                      }}>
                        <div style={{
                          width: 36, height: 36, borderRadius: "50%",
                          border: "3px solid #dee2e6",
                          borderTopColor: "#3d8ecc",
                          animation: "spin 0.8s linear infinite"
                        }} />
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                        <p style={{ color: "#999", fontSize: "13px", margin: 0 }}>Loading data...</p>
                      </div>
                    ) : (
                      <>
                        <BarAnalysisChart title="Units Sold by Year" data={yearUnitSold} yAxisLabel="Units" variant="combo" />
                        <BarAnalysisChart title="Revenue by Year" data={yearRevenue} yAxisLabel="Revenue" variant="combo" />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterStrict />
    </>
  );
};

const formatLocalDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export default ItemCategoryAnalyzer;
